// extracted by mini-css-extract-plugin
module.exports = {"container":"JournalActingLsrLevel_container__3z23F","lsrRow":"JournalActingLsrLevel_lsrRow__3eLTU","lsrName":"JournalActingLsrLevel_lsrName__3aWWX"};